import React from 'react';
import "./CustomLoader.scss";

const CustomLoader = () => (
  <div className="custom-loader">
    <div className="custom-loader-spinner"></div>
  </div>
);

export default CustomLoader;